// extracted by mini-css-extract-plugin
export default {"wrapper":"c2-z","play":"d2-z"};